export const CIVILBUDGETMATERIAL_LOADING = "CIVILBUDGETMATERIAL_LOADING";
export const CIVILBUDGETMATERIAL_RESET = "CIVILBUDGETMATERIAL_RESET";
export const GET_CIVILBUDGETMATERIAL = "GET_CIVILBUDGETMATERIAL";
export const GET_CIVILBUDGETMATERIAL_SUCCESS = "GET_CIVILBUDGETMATERIAL_SUCCESS";
export const GET_CIVILBUDGETMATERIAL_FAIL = "GET_CIVILBUDGETMATERIAL_FAIL";
export const DELETE_CIVILBUDGETMATERIAL = "DELETE_CIVILBUDGETMATERIAL"
export const DELETE_CIVILBUDGETMATERIAL_SUCCESS = "DELETE_CIVILBUDGETMATERIAL_SUCCESS"
export const DELETE_CIVILBUDGETMATERIAL_FAIL = "DELETE_CIVILBUDGETMATERIAL_FAIL"
export const UPDATE_CIVILBUDGETMATERIAL = "UPDATE_CIVILBUDGETMATERIAL"
export const UPDATE_CIVILBUDGETMATERIAL_SUCCESS = "UPDATE_CIVILBUDGETMATERIAL_SUCCESS"
export const UPDATE_CIVILBUDGETMATERIAL_FAIL = "UPDATE_CIVILBUDGETMATERIAL_FAIL"
export const ADD_NEW_CIVILBUDGETMATERIAL = "ADD_NEW_CIVILBUDGETMATERIAL"
export const ADD_CIVILBUDGETMATERIAL_SUCCESS = "ADD_CIVILBUDGETMATERIAL_SUCCESS"
export const ADD_CIVILBUDGETMATERIAL_FAIL = "ADD_CIVILBUDGETMATERIAL_FAIL"